import React from 'react';
export function CourseCosts() {
  return <div className="w-full" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-1091">
      <div className="max-w-4xl mx-auto px-4 md:px-8" data-id="element-1092">
        <div className="mb-12" data-id="element-1093">
          <h2 className="text-2xl md:text-3xl font-bold uppercase mb-6" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-1094">
            Course Costs
          </h2>
          <div className="bg-white rounded-xl overflow-hidden shadow-sm border" style={{
          borderColor: '#ede9e0'
        }} data-id="element-1095">
            <div className="overflow-x-auto" data-id="element-1096">
              <table className="w-full text-left border-collapse" data-id="element-1097">
                <thead data-id="element-1098">
                  <tr style={{
                  backgroundColor: '#1e3d2f'
                }} data-id="element-1099">
                    <th className="p-4 font-semibold text-sm uppercase tracking-wider" style={{
                    color: '#ffffff',
                    fontFamily: 'Inter, sans-serif'
                  }} data-id="element-1100">
                      Membership
                    </th>
                    <th className="p-4 font-semibold text-sm uppercase tracking-wider" style={{
                    color: '#c8a84b',
                    fontFamily: 'Inter, sans-serif'
                  }} data-id="element-1101">
                      Tuition
                    </th>
                  </tr>
                </thead>
                <tbody data-id="element-1102">
                  <tr className="border-b" style={{
                  borderColor: '#ede9e0'
                }} data-id="element-1103">
                    <td className="p-4 font-medium text-gray-800" data-id="element-1104">
                      FLSC Members
                    </td>
                    <td className="p-4 font-bold text-[#1e3d2f]" data-id="element-1105">$35.00</td>
                  </tr>
                  <tr data-id="element-1106">
                    <td className="p-4 font-medium text-gray-800" data-id="element-1107">
                      Non-Members
                    </td>
                    <td className="p-4 font-bold text-[#1e3d2f]" data-id="element-1108">$60.00</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>;
}